import Component from './Component';
import axios from 'axios';
import { onKeyUp } from './../services/DocumentEvents'

/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */
 let searchPromise;

 const noResultsTemplate = `
    <div class="c-search__no-results [ u-tac ]">
        <h4 class="c-search__no-results__heading">Your search returned no results.</h4>
    </div>
`;



/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */

function highlight(data, search) {
    let regex = new RegExp('(' + search + ')', 'gi');
    return data.replace(regex, '<b>$1</b>')
}








/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */



export default class SearchOverlay extends Component {

    decorator () {
        return {
            selector : '.js-search-overlay',
            name : 'SearchOverlay',
        }
    }


    constructor(element) {
        super(element);

        // INITIAL CALLS
        this.cacheElements();
    }


    cacheElements () {
        this.form = this.element.querySelector('.js-search-overlay-form');
        this.textbox = this.form.elements['search_text'];
        this.suggestions = this.element.querySelector('.js-search-suggestions');

        this.form.addEventListener('submit', e => {
            e.preventDefault();
            window.location.href = `/search?q=${this.textbox.value}`;
        });

        onKeyUp(this.handleSearch.bind(this));
    }


    handleSearch (e) {
        if (e.target.name != 'search_text') { return; }

        if (e.target.value == '') {
            this.suggestions.innerHTML = '';
            this.suggestions.classList.remove('is-visible');
            return;
        }

        return this.search(e.target.value);
    }


    search (value) {

        searchPromise = axios.get(`/api/search/suggestion?q=${value}`)
            .then(response => {
                return response.data;
            })
            .then(data => {
                this.suggestions.innerHTML = '';
                this.suggestions.classList.add('is-visible');

                if (data.length < 1) {
                    this.suggestions.insertAdjacentHTML('beforeend', noResultsTemplate);
                    return;
                }

                for (let i = 0; i < data.length; i++) {
                    let test = highlight(data[i].title, value);
                    const template = `<li><a href="${data[i].url}" title="${data[i].title}">${test}</a></li>`;

                    this.suggestions.insertAdjacentHTML('beforeend', template);
                }
            })
            .catch(error => {
                console.error(error);
            })
    }

}
